//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { useContext } from 'react';
import { HelpContext } from '@/contexts/HelpContext';

// Access help/tour state and actions (see HelpContextValue).
export const useHelp = () => {
  const context = useContext(HelpContext);
  if (context === undefined)
    throw new Error('useHelp must be used within a HelpProvider');

  return context;
};
